// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kh-0";
export var buttonContainer = "_kh-3";
export var cancelButton = "_kh-4";
export var headerSection = "_kh-6";
export var headerTitle = "_kh-9";
export var messageSideLeft = "_kh-1";
export var messageSideRight = "_kh-2";
export var orderNumberContainer = "_kh-7";
export var orderNumberLabel = "_kh-8";
export var submitButton = "_kh-5";